<!--
 * @Description: 资产维修
 * @Author: PF
 * @Date: 2023-12-11 16:50:24
 * @LastEditors: PF
 * @LastEditTime: 2024-07-10 14:55:28
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">资产维修</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column type="index" label="序号" align="center" width="80" />
              <el-table-column label="标题" prop="bt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="地点" prop="dd" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="处理状态" prop="clzt.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="报修人" prop="cjjzgxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="维修时间" prop="wxsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="维修结果" prop="wxjg" align="center" show-overflow-tooltip />
              <el-table-column label="退回说明" prop="thsm" align="center" show-overflow-tooltip />
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="110" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="clztData.yiPaiGong === scope.row.clzt.value" @click="openWeiXiu=true; row=scope.row">维修</el-button>
                  <el-button link type="warning" v-if="clztData.yiPaiGong === scope.row.clzt.value" @click="openYuanYin=true; row=scope.row">退回</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <weixiu v-if="openWeiXiu" v-model:openWeiXiu="openWeiXiu" :row="row" @ReturnData="bindTable" />
  <el-dialog v-model="openYuanYin" title="退回说明" class="w500 h340" :before-close="handleClose">
    <el-form ref="ruleFormRef" :model="ruleForm" label-width="0">
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="thsm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model="ruleForm.thsm" type="textarea" resize="none" :autosize='{minRows: 6, maxRows: 6}' />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <div></div>
        <div class="footer_but">
          <el-button type="primary" @click="tuiHuiClick()">保存</el-button>
          <el-button type="info" @click="handleClose()">关闭</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, unref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  homeCloseWindow,
  actionPost,
  loadSelect
} from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'
import weixiu from './weixiu.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'wxsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/houqin/baoxiu/chaxunwodeweixiu',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openList = ref(false)
const openWeiXiu = ref(false)
const openYuanYin = ref(false)

const ruleFormRef = ref(null)
const ruleForm = ref({})
const handleClose = () => {
  openYuanYin.value = false
}
// 退回
const tuiHuiClick = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  actionPost({ url: '/api/v2/houqin/baoxiu/tuihuibaoxiu/' + row.value.id, data: { id: row.value.id, thsm: ruleForm.value.thsm } }).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      handleClose()
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}
const clztData = ref({ list: [] }) // 处理状态
watch(
  () => props.open,
  () => {
    if (props.open === 'zichanweixiu') {
      openList.value = true
      loadSelect({ url: '/api/v2/houqin/baoxiu/chulizhuangtai', data: clztData })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
